import { IDayID, IWeekly } from '@/types/BusinessHours';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import DayScheduleInput from './components/day-schedule-input.component';

interface IProps {
	isLoading?: boolean;
	value: IWeekly;
	onChange: (value: any) => void;
}

export default function ScheduleInput(props: IProps) {
	const { t } = useTranslation();

	function handleChange(id: IDayID, value: Array<{ start: string; end: string }>) {
		const newValue = { ...props.value };
		newValue[id] = value;
		props.onChange(newValue);
	}

	/**
	 * Repeat the available hours from Monday to Friday
	 */
	function handleRepeatClick(id: IDayID) {
		const newValue = { ...props.value };
		const valueToRepeat = newValue[id];
		newValue.MONDAY = valueToRepeat;
		newValue.TUESDAY = valueToRepeat;
		newValue.WEDNESDAY = valueToRepeat;
		newValue.THURSDAY = valueToRepeat;
		newValue.FRIDAY = valueToRepeat;
		props.onChange(newValue);
	}

	return (
		<Box display="grid" gridTemplateRows="repeat(7, auto)" gap={4}>
			<DayScheduleInput
				onRepeatClick={() => handleRepeatClick('MONDAY')}
				isLoading={props.isLoading}
				name={t('Monday')}
				value={props.value.MONDAY}
				onChange={(value) => handleChange('MONDAY', value)}
			/>
			<DayScheduleInput
				onRepeatClick={() => handleRepeatClick('TUESDAY')}
				isLoading={props.isLoading}
				name={t('Tuesday')}
				value={props.value.TUESDAY}
				onChange={(value) => handleChange('TUESDAY', value)}
			/>
			<DayScheduleInput
				onRepeatClick={() => handleRepeatClick('WEDNESDAY')}
				isLoading={props.isLoading}
				name={t('Wednesday')}
				value={props.value.WEDNESDAY}
				onChange={(value) => handleChange('WEDNESDAY', value)}
			/>
			<DayScheduleInput
				onRepeatClick={() => handleRepeatClick('THURSDAY')}
				isLoading={props.isLoading}
				name={t('Thursday')}
				value={props.value.THURSDAY}
				onChange={(value) => handleChange('THURSDAY', value)}
			/>
			<DayScheduleInput
				onRepeatClick={() => handleRepeatClick('FRIDAY')}
				isLoading={props.isLoading}
				name={t('Friday')}
				value={props.value.FRIDAY}
				onChange={(value) => handleChange('FRIDAY', value)}
			/>
			<DayScheduleInput
				onRepeatClick={() => handleRepeatClick('SATURDAY')}
				isLoading={props.isLoading}
				name={t('Saturday')}
				value={props.value.SATURDAY}
				onChange={(value) => handleChange('SATURDAY', value)}
			/>
			<DayScheduleInput
				onRepeatClick={() => handleRepeatClick('SUNDAY')}
				isLoading={props.isLoading}
				name={t('Sunday')}
				value={props.value.SUNDAY}
				onChange={(value) => handleChange('SUNDAY', value)}
			/>
		</Box>
	);
}
